<template lang="html">
  <b-row>
    <b-col>
      <b-btn
        :size="size"
        class="mr-1"
        :variant="returnVariant('timeline')"
        :disabled="!showHasAudio"
        @click="gotoMode('timeline')"
      >
        Timeline <v-icon name="stream" />
      </b-btn>
      <b-btn
        v-if="$store.state.show.editableOverlays"
        :size="size"
        class="mr-1"
        :variant="returnVariant('overlays')"
        @click="gotoMode('overlays')"
      >
        Overlays <v-icon name="edit" />
      </b-btn>
      <b-btn
        :size="size"
        class="mr-1"
        :variant="returnVariant('settings')"
        @click="gotoMode('settings')"
      >
        Settings <v-icon name="cog" />
      </b-btn>
      <b-btn
        :size="size"
        class="mr-1"
        :variant="returnVariant('export')"
        @click="gotoMode('export')"
      >
        Export <v-icon name="download" />
      </b-btn>
      <b-dropdown id="dropdown-1" :size="size" :variant="nonActiveVariant">
        <template slot="button-content">
          More <v-icon name="tools" />
        </template>
        <b-dropdown-item
          :disabled="$store.getters.restrictShowCreation"
          @click="duplicateShow"
        >
          Duplicate <v-icon name="copy" class="ml-2" />
        </b-dropdown-item>
        <b-dropdown-item variant="danger" @click="confirmDeletion">
          Delete
          <v-icon name="trash-alt" class="ml-2" />
        </b-dropdown-item>
      </b-dropdown>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "ModeBar",
  data() {
    return {
      activeVariant: "primary",
      nonActiveVariant: "outline-secondary",
      size: "md"
    };
  },
  computed: {
    mode() {
      return this.$route.params.mode || "timeline";
    },
    privateShow() {
      return this.$store.getters["show/isShowPrivate"];
    },
    showHasAudio() {
      return this.$store.getters["show/showHasAudio"];
    }
  },
  methods: {
    gotoMode(mode) {
      // Check to see if current mode == destination mode,
      // if so, return (to prevent NavigationDuplicated).
      if (mode == this.mode) {
        return;
      }
      var key = this.$store.state.show.currentShowKey;
      this.$router.push({ name: "show-mode", params: { id: key, mode: mode } });
    },
    returnVariant(mode) {
      if (this.mode == mode) {
        return this.activeVariant;
      } else {
        return this.nonActiveVariant;
      }
    },
    duplicateShow() {
      var key = this.$store.state.show.currentShowKey;
      this.$store.dispatch("showCreation/duplicateShowByKey", key);
      this.$router.push({ name: "shows" }).catch(() => {});
    },
    confirmDeletion() {
      var _v = this;
      var show = this.$store.state.show.currentShow;
      this.$bvModal
        .msgBoxConfirm("This action will remove the show from your account.", {
          title: "Confirm delete?",
          okTitle: "Delete",
          okVariant: "danger"
        })
        .then(value => {
          console.log("confirm", value);
          if (value === true) {
            _v.$store.dispatch("shows/deleteShow", show);
          }
        })
        .catch(err => {
          // An error occurred
          throw err;
        });
    }
  }
};
</script>

<style lang="css" scoped></style>
